import { GetCaption } from '@/utils/util.language'
import router from '@/router'
import store from '@/store'
import { AUTH_SET_REDIRECT } from '@/store/types'

export function findIn2dArray<Element>(
  predicate: (value: Element) => boolean,
  arr: Element[][]
): Element | undefined {
  for (const innerArray of arr) {
    const found = innerArray?.find(predicate)

    if (found) {
      return found
    }
  }

  return undefined
}

export function toTwoDp(stringNumber: string): string {
  return (Math.round(Number(stringNumber) * 100) / 100).toFixed(2)
}

export function getISODate(date: Date): string {
  const tzOffset: number = new Date().getTimezoneOffset() * 60000
  return new Date(date.getTime() - tzOffset).toISOString().slice(0, 10)
}

const days = [
  'SUNDAY',
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
].map((day) => GetCaption(day))

const months = [
  'JANUARY',
  'FEBRUARY',
  'MARCH',
  'APRIL',
  'MAY',
  'JUNE',
  'JULY',
  'AUGUST',
  'SEPTEMBER',
  'OCTOBER',
  'NOVEMBER',
  'DECEMBER',
].map((month) => GetCaption(month))

export function ISODateToFormatted(date: string): string {
  const dateObj = new Date(date)
  const day = days[dateObj.getDay()]
  const dayOfMonth = dateObj.getDate()
  const month = months[dateObj.getMonth()]
  const year = (dateObj.getFullYear() + '').slice(2)

  return `${day}, ${dayOfMonth} ${month} ${year}`
}

export function getRedemptionTime(redeemedAt: string): string {
  const redemptionDate = new Date(redeemedAt)
  const minutes = redemptionDate
    .getMinutes()
    .toString()
    .padStart(2, '0')
  let hours: string | number = redemptionDate.getHours()
  const period = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12
  hours = hours || 12 // the hour 0 should be 12
  hours = hours.toString().padStart(2, '0')

  return `${hours}:${minutes}${period}`
}

export function ISOTimeToFormatted(date: string): string {
  const redemptionDate = new Date(date)
  const minutes = redemptionDate
    .getMinutes()
    .toString()
    .padStart(2, '0')
  let hours: string | number = redemptionDate.getHours()
  const period = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12
  hours = hours || 12 // the hour 0 should be 12
  hours = hours.toString().padStart(2, '0')

  return `${hours}:${minutes}${period}`
}

const monthsShort = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
].map((month) => GetCaption(month))
export function ISODateToRedemption(date: string): string {
  const dateObj = new Date(date)
  const dayOfMonth = dateObj.getDate()
  const month = monthsShort[dateObj.getMonth()]
  const year = (dateObj.getFullYear() + '').slice(2)

  return `${dayOfMonth} ${month} ${year}`
}

export function removeFromArray<T>(predicate: (value: T) => boolean, arr: T[]): T[] {
  const indexToRemove = arr.findIndex(predicate)
  if (indexToRemove !== -1) {
    const newArr = [...arr]
    newArr.splice(indexToRemove, 1)
    return newArr
  } else {
    return arr
  }
}

export function getPath(path: string): string {
  const { lang, merchant } = router.app.$route.params
  const basePath = lang && merchant ? `/lang/${lang}/${merchant}` : ''
  return `${basePath}${path}`
}

export function getTodaysDate(): Date {
  const date = new Date()
  date.setHours(0, 0, 0, 0)
  return date
}

export function isBeforeToday(dateOfVisit: string): boolean {
  const dateObj = new Date(dateOfVisit)
  dateObj.setHours(0, 0, 0, 0)

  return dateObj < getTodaysDate()
}

export function replaceAtIndex<T>(index: number, arr: T[], newValue: T): T[] {
  const result = [...arr]
  result[index] = newValue
  return result
}

export function removeAtIndex<T>(index: number, arr: T[]): T[] {
  const result = [...arr]
  result.splice(index, 1)
  return result
}

export function pathAfterSignIn(defaultPath: string): string {
  const redirectPathAfterAuth = store.state.auth.redirectPathAfterAuth
  if (redirectPathAfterAuth) {
    store.commit(AUTH_SET_REDIRECT, undefined)
    return redirectPathAfterAuth
  } else {
    return defaultPath
  }
}

export function isDuplicatedInArray(element: string, arr: string[]): boolean {
  const n = 4
  return arr.filter((value) => value.slice(-n) === element.slice(-n)).length > 1
}

export function timeWithColon(time: string): string {
  return time.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ':')
}

export function cleanHtmlTags(text: string): string {
  return text.replace(/<[^>]+>/g, '')
}

export function isBase64(str: string): boolean {
  if (str === '' || str.trim() === '') return false
  try {
      return btoa(atob(str)) === str
  } catch (err) {
      return false
  }
}

export function getBase64Id(id: string): string {
  if (isBase64(id)) {
    return id
  } else {
    return btoa(id)
  }
}
